/**
 * flowSayTextAtom.ts
 * フロー実行中の sayText 情報を共有する Jotai atom
 * SayText ノード実行時にテキストを設定し、VirtualRobot でふきだしを表示する
 */
import { atom } from 'jotai';
import { completionOnce } from './completionOnce';

export interface FlowSayTextInfo {
  text: string;
  duration: number;  // ふきだし表示時間（ミリ秒）
  requestId: number;
  onComplete?: () => void;
}

/**
 * フロー実行中の sayText 情報
 * SayText ノード実行時にセットされ、VirtualRobot がこれを監視してふきだしを表示する
 * 表示完了時に onComplete コールバックが呼ばれる
 */
export const flowSayTextAtom = atom<FlowSayTextInfo | null>(null);

/**
 * 書き込み用 atom。
 * 前の要求が未完了のまま上書き、または null リセットされるとき、
 * 前の onComplete を必ず呼んでフロー側の待機を解決する。
 */
export const setFlowSayTextAtom = atom(
  null,
  (get, set, next: FlowSayTextInfo | null) => {
    get(flowSayTextAtom)?.onComplete?.();
    set(flowSayTextAtom, next ? { ...next, onComplete: completionOnce(next.onComplete) } : null);
  },
);
